export default __webpack_public_path__ + "static/media/taskq.c3449440.PNG";